<template>
  <div class="wrapper">
    <div
      v-if="isFocused && !prop.disabled"
      :class="{ title: !isFilled, title_focus: isFocused }"
    >
      {{ prop.placeholder }}
    </div>
    <div
      v-else-if="!isFocused && isFilled && !errorMessage && !prop.disabled"
      class="title"
    >
      {{ prop.placeholder }}
    </div>
    <div v-else-if="errorMessage && !prop.disabled" class="titleError">
      {{ prop.placeholder }}
    </div>
    <div
      v-else-if="!isFocused && isFilled && !errorMessage && prop.disabled"
      class="titleDisabled"
    >
      {{ prop.placeholder }}
    </div>
    <!-- TODO -->
    <div v-else-if="prop.fieldName == 'occupationType'" class="title">
      {{ prop.placeholder }}
    </div>

    <Field
      v-model="inputValue"
      class="form-select"
      :class="[
        {
          'placeholder-text': !inputValue,
          focused: isFocused,
          inputError: errorMessage,
        },
        deviceType,
        isCountryCode ? 'countryCode' : '',
      ]"
      as="select"
      aria-label=".form-select-lg example"
      @change="emitSelection"
      :name="field"
      :required="required"
      :placeholder="placeholderHidden"
      @mousedown.stop="handleClick"
      :default="default"
      @blur="handleBlurOut"
      @focus="handleFocus"
      :clear="clear"
      :character="character"
      :disabled="disabled"
    >
      <option v-if="options.length == 0">
        {{ t("ccOnBoarding.uploadDocument.loading2") }}
      </option>
      <option value="" disabled selected>
        {{ placeholderHidden }}
      </option>
      <option
        v-if="!character"
        class="option"
        v-for="option in options"
        :key="option ? option.toString() : ''"
        :value="option ? option.code : ''"
      >
        {{ option?.value }}
      </option>
      <option
        v-if="character"
        class="option"
        v-for="option in options"
        :key="option ? option.toString() : ''"
        :value="option ? option.code : ''"
      >
        {{ option?.value }}
      </option>
    </Field>
    <!-- <pre class="help" v-if="!errorMessage"> {{ errorMessage }}</pre> -->
    <pre class="help"> {{ errorMessage }}</pre>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  type PropType,
  watch,
  nextTick,
  computed,
  onBeforeMount,
} from "vue";
import { Field, useField } from "vee-validate";
import i18n from "@/plugin/i18n";
import ProgressRoutePage from "../ProgressRoutePage.vue";
import { deviceDetect } from "mobile-device-detect";

const { t } = i18n.global;
const emit = defineEmits(["update:modelValue"]);

interface option {
  code: String;
  value: String;
}

const prop = defineProps({
  border: {
    type: String,
  },
  options: {
    type: Array as PropType<Array<option>>,
    required: true,
  },
  placeholder: {
    type: String,
    required: true,
  },
  selectedOption: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
  },
  validateRule: {
    type: String,
  },
  validationType: {
    type: String,
    default: "",
  },
  field: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    required: false,
  },
  default: {
    type: Boolean,
  },
  defaultValue: {
    type: String,
  },
  clear: {
    type: String,
  },
  character: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  fieldName: {
    type: String,
    default: "",
  },
  isCountryCode: {
    type: Boolean,
    default: false,
  },
});

const isFocused = ref(false);
const isFilled = ref(false);
const inputValue = ref(prop.modelValue || prop.defaultValue || "");
const deviceType = ref("");

onBeforeMount(() => {
  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

if (prop.modelValue) {
  isFilled.value = true;
}

const { value, errorMessage, handleBlur } = useField(
  () => prop.field,
  prop.validateRule,
  {
    validateOnValueUpdate: false,
  }
);

watch(
  () => prop.defaultValue,
  (newValue) => {
    if (prop.defaultValue !== "" && newValue !== undefined) {
      isFilled.value = true;
      inputValue.value = newValue;
      errorMessage.value = "";
      emit("update:modelValue", inputValue.value);
    } else {
      inputValue.value = "";
      isFilled.value = false;
    }
  }
);
if (prop.defaultValue !== "" && prop.defaultValue !== undefined) {
  isFilled.value = true;
  emit("update:modelValue", inputValue.value);
}

if (prop.defaultValue == "") {
  isFilled.value = false;
}

const emitSelection = (event: Event) => {
  event.preventDefault();
  isFocused.value = false;
  isFilled.value = true;
  emit("update:modelValue", inputValue.value);
};

const placeholderHidden = computed(() => {
  return isFocused.value ? "" : prop.placeholder;
});

const handleFocus = () => {
  isFocused.value = true;
  isFilled.value = false;
};

const handleClick = () => {
  setTimeout(() => {
    isFocused.value = true;
    isFilled.value = true;
  }, 0);
};

const handleBlurOut = () => {
  nextTick(() => {
    if (document.activeElement !== document.querySelector(".form-select")) {
      isFocused.value = false;
      isFilled.value = false;
      if (inputValue.value == "") {
        isFilled.value = false;
        isFocused.value = false;
      } else {
        isFilled.value = true;
        isFocused.value = false;
      }
    }
  });
};

watch(inputValue, (newValue) => {
  value.value = newValue;
});

watch(
  () => prop.clear,
  (newValue) => {
    if (newValue) {
      if (prop.field == "emplomentType" || prop.field == "branch") {
        inputValue.value = "";
        emit("update:modelValue", "");
      }
    }
  }
);
</script>

<style scoped>
.wrapper {
  position: relative;
}
.form-select {
  border: 2px solid #dbdfea;
  padding: 14px 31px 14px 22px;
  border-radius: 10px;
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  font: 400 16px/130% "Outfit", sans-serif;
  box-sizing: border-box;
}

.form-select option {
  padding-left: 0px;
  margin-left: 0px;
}

.inputError {
  border: 2px solid red;
  /*padding: 14px 31px 14px 0px;*/
  border-radius: 10px;
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  font: 400 16px/130% "Outfit", sans-serif;
  outline-color: #ac2887;
}

.form-select.focused {
  border-color: #ac2887;
  width: 100%;
}

.help {
  color: red;
  margin-bottom: 0px;
  margin-top: 8px;
  font: 400 16px/130% "Outfit", sans-serif;
}

.placeholder-text {
  color: var(--black-low-38, rgba(0, 0, 0, 0.38));
  font: var(--subtitle-1-medium, 500 16px/130% "Outfit", sans-serif);
  padding-left: 22px;
}

select:required:invalid {
  color: gray;
}
option[value=""][disabled] {
  display: none;
}
option {
  color: black;
}

.option {
  font-family: "Outfit";
}

select {
  background-size: 24px 24px;
  background-position: right 8px center;
  background-image: url("@/svg/Others (24).svg");
}

select:required:invalid {
  color: var(--black-low-38, rgba(0, 0, 0, 0.38));
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

option {
  color: rgba(0, 0, 0, 0.87);
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.274px;
}

.form-select:focus {
  box-shadow: none;
}

.title {
  position: absolute;
  top: -8px;
  left: 15px;
  color: rgba(0, 0, 0, 0.38);
  font: 500 12px/130% "Outfit", sans-serif;
  background-color: white;
  padding: 0 5px;
}

.titleError {
  position: absolute;
  top: -8px;
  left: 15px;
  color: red;
  font: 500 12px/130% "Outfit", sans-serif;
  background-color: white;
  padding: 0 5px;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title_focus {
  position: absolute;
  top: -8px;
  left: 15px;
  color: #ac2887;
  font: 500 12px/130% "Outfit", sans-serif;
  background-color: white;
  padding: 0 5px;
  opacity: 0;
  transform: translateY(100%);

  /* Animation */
  animation: slideIn 0.3s ease-out forwards;
}

.form-select[disabled] {
  background-color: #dbdfea !important;
}

.titleDisabled {
  position: absolute;
  top: -8px;
  left: 15px;
  color: rgba(0, 0, 0, 0.38);
  font: 500 12px/130% "Outfit", sans-serif;
  background: linear-gradient(to bottom, white 52%, #dbdfea 48%);
  padding: 0 5px;
}

.countryCode:is(.Mobile) {
  background-position: right 10% center;
  padding: 14px 20px 14px 20%;
}
</style>
